import { z } from 'zod'

export const SeriesLabelCreateSchema = z.object({
  name: z.string().min(1, { message: 'Please enter a name' }),
  imaging_modality_id: z.string().uuid().min(1, { message: 'Please select an imaging modality.' }),
  allow_qc_to_duplicate: z.boolean(),
})
